/* eslint-disable */
import { connect, } from "react-redux";
import { createStructuredSelector, } from "reselect";


import { isFrontshopOrder, } from "ggApp/modules/order/selectors";

/**
 * withHasBackToCartLink
 * @description This HOC is using to render CheckoutBackToCartLink
 * only when the current order doesn't come from PartnerPOS
 * @param {React.ComponentType} WrappedComponent React Component to be enhanced
 * @returns {React.ComponentType} Enhanced Component
 */
function withHasBackToCartLink(WrappedComponent) {
    const enhance = connect(
        createStructuredSelector({
            hasBackToCartLink: isFrontshopOrder,
        })
    );

    return enhance(WrappedComponent);
}

export { withHasBackToCartLink, }
